const config = require('../config'); const apiConfig = require('../api-config');
const keyBy = require('lodash/keyBy');
const pathResult = require('../resources/path-result');
const apiFactory = require('../resources/maturities-ch/api-factory');
const serviceFactory = require('../resources/maturities-ch/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/maturities/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}maturitiesByIdCh[{keys:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].assets.length`,
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities => res.value(maturities.length))
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{keys:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].assets[{integers:index}][{keys:k}]`,
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities =>
              pathResult([req.params.index, req.params.k], res, maturities)
            )
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{keys:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].otherPeriodAssets.length`,
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityOtherPeriodAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities => res.value(maturities.length))
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{keys:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].otherPeriodAssets[{integers:index}][{keys:k}]`,
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityOtherPeriodAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities =>
              pathResult([req.params.index, req.params.k], res, maturities)
            )
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{keys:portfolioId}].maturityDates`,
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityInNextOneYear(req.params.metaData, req.params.portfolioId)
            .then(dates => res.value(JSON.stringify(dates)))
            .catch(res.error)
      )))

      // WMCE-4443 , BP CONSOLIDATION -- BELOW PATHS TO MATCH BP IDS AS INTEGERS 
      .match(`${p}maturitiesByIdCh[{integers:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].assets.length`, 
      requests => Promise.all(
        requests.map(({ req, res }) => 
          service.getMaturityAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities => res.value(maturities.length))
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{integers:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].assets[{integers:index}][{keys:k}]`, 
      requests => Promise.all(
        requests.map(({ req, res }) => 
          service.getMaturityAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities => 
              pathResult([req.params.index, req.params.k], res, maturities)
            )
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{integers:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].otherPeriodAssets.length`, 
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityOtherPeriodAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities => res.value(maturities.length))
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{integers:portfolioId}].dates[{keys:fromDate}][{keys:toDate}].otherPeriodAssets[{integers:index}][{keys:k}]`, 
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityOtherPeriodAssets(req.params.metaData, req.params.portfolioId, req.params.fromDate, req.params.toDate)
            .then(maturities =>
              pathResult([req.params.index, req.params.k], res, maturities)
            )
            .catch(res.error)
        )))
    .match(`${p}maturitiesByIdCh[{integers:portfolioId}].maturityDates`,
      requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getMaturityInNextOneYear(req.params.metaData, req.params.portfolioId)
            .then(dates => res.value(JSON.stringify(dates)))
            .catch(res.error)
      )))
}

module.exports = addRoutes;
